import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { IonRow } from '@ionic/react';
import { RootState } from '../../models/RootState';
import deposit from '../../assets/images/common/icons/deposit.png';
import { Tabs, Tab, Button, TextField } from '@material-ui/core';
import bank from '../../assets/images/common/icons/bank.svg';
import './Payment.scss';
import './Deposit.scss';
import AGPAY_API from '../../api-services/feature-api';
import { toast } from 'react-toastify';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import SuccessIcon from '@material-ui/icons/CheckCircleOutline';
import Spinner from '../../components/Spinner/Spinner';
import { setOpenDepositModal } from '../../store';
import { AccountDetails } from './AccountDetails';
import { useHistory } from 'react-router';
import AbcMoney from './DepositTabPanels/AbcMoney';
import {
  PaymentMethodsInfo,
  PaymentOptions,
  StoreProps,
} from './Deposit.types';
import Pgman from './DepositTabPanels/Pgman';
import XenonPay from './DepositTabPanels/XenonPay';
import { AvailablePaymentGateways } from '../../util/stringUtil';

const Deposit: React.FC<StoreProps> = (props) => {
  const { setOpenDepositModal } = props;
  const [tabValue, setTabValue] = useState<number>(0);
  const [paymentOption, setPaymentOption] = useState<string>('NEFT');
  const [accountDetails, setAccountDetails] = useState<AccountDetails[]>();
  const [selectedAccountId, setSelectedAccountId] = useState<string>();
  const [depositAmount, setDepositAmount] = useState<string>();
  const [depositNotes, setDepositNotes] = useState<string>();
  const [referenceId, setReferenceId] = useState<string>();
  const [depositImage, setDepositImage] = useState<string | ArrayBuffer>();
  const [loading, setLoading] = useState<boolean>(false);
  const [onlinePaymentOption, setOnlinePaymentOption] =
    useState<string>('BANK_TRANSFER');
  const [mobileNumber, setMobileNumber] = useState<string>();
  const [paymentDetails, setPaymentDetails] = useState<PaymentOptions[]>();
  const [providerRefId, setProviderRefId] = useState<string>();
  const [providersList, setProvidersList] = useState([]);
  const [depositPaymentMethodsInfo, setDepositPaymentMethodsInfo] =
    useState<PaymentMethodsInfo>();
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [paymentOptionFilter, setPaymentOptionFilter] =
    useState<string>('IMPS');
  const [ocrDepositAmount, setOcrDepositAmount] = useState<string>();
  const [ocrReferenceId, setOcrReferenceId] = useState<string>();
  const [paymentGatewaysCount, setPaymentGatewaysCount] = useState<number>(0);
  const hiddenFileInput = useRef(null);
  let count = 0;

  const history = useHistory();

  const successToast = (mess: string) => {
    toast.success(
      <div>
        <SuccessIcon /> {mess}
      </div>,
      {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      }
    );
  };

  const errorToast = (mess: string) => {
    toast.error(
      <div>
        <ErrorIcon /> {mess}
      </div>,
      {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      }
    );
  };

  const getImageDetails = async () => {
    setLoading(true);
    setDepositAmount('');
    setOcrDepositAmount('');
    setReferenceId('');
    setOcrReferenceId('');
    try {
      const payload = {
        payment_option:
          paymentOption === 'NEFT'
            ? paymentOptionFilter
            : paymentOption === 'UPI'
            ? 'UPI'
            : 'PAYTM_WALLET',
        image: depositImage,
      };

      const response = await AGPAY_API.post(
        `/agpay/v2/ocr/get-details`,
        payload,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
          timeout: 20000,
        }
      );

      if (response.status === 200 && response?.data) {
        const data = response.data;
        const amount = data.amount.trim();
        const utr = data.utr.trim();

        setDepositAmount(amount);
        setOcrDepositAmount(amount);
        setReferenceId(utr);
        setOcrReferenceId(utr);

        if (amount === '' || utr === '') {
          errorToast('Please enter details manually!');
        } else {
          successToast('Details entered successfully!');
        }
      } else {
        errorToast('Something went wrong.');
      }

      setLoading(false);
    } catch (error) {
      errorToast(error?.response?.data?.message);
      setLoading(false);
    }
  };

  const getUtr = async () => {
    setLoading(true);
    setReferenceId('');
    setOcrReferenceId('');
    try {
      const payload = {
        payment_option:
          paymentOption === 'NEFT'
            ? paymentOptionFilter
            : paymentOption === 'UPI'
            ? 'UPI'
            : 'PAYTM_WALLET',
        image: depositImage,
      };

      const response = await AGPAY_API.post(`/agpay/v2/ocr/get-utr`, payload, {
        headers: {
          Authorization: sessionStorage.getItem('jwt_token'),
        },
        timeout: 20000,
      });

      if (response.status === 200 && response?.data) {
        var utr = response.data;
        setReferenceId(utr);
        setOcrReferenceId(utr);
        if (utr === '') {
          errorToast('Please enter details manually!');
        } else {
          successToast('UTR entered successfully!');
        }
      } else {
        errorToast('Something went wrong.');
      }

      setLoading(false);
    } catch (error) {
      errorToast(error?.response?.data?.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (
      depositImage !== undefined &&
      depositImage !== null &&
      depositImage !== ''
    ) {
      if (tabValue === 1) {
        getImageDetails();
      } else if (tabValue === 0) {
        getUtr();
      }
    }
  }, [depositImage]);

  const fetchPaymentMethod = async () => {
    try {
      const response = await AGPAY_API.get(`/agpay/v2/pgman/payment-methods`, {
        headers: {
          Authorization: sessionStorage.getItem('jwt_token'),
        },
        params: {
          admin: true,
          paymentOption:
            paymentOption === 'GPAY' || paymentOption === 'PHONEPE'
              ? 'UPI'
              : paymentOption,
        },
      });
      if (response.status === 200) {
        let accountsArr = [];
        response.data.map((i) => {
          if (!i.disabled) accountsArr.push(i);
        });
        setAccountDetails(accountsArr);
        const initialSelectedAccount = accountsArr[0];
        setSelectedAccount(initialSelectedAccount);
        setSelectedAccountId(initialSelectedAccount?.id?.toString());
      } else {
      }
    } catch (error) {}
  };

  const getPaymentProviders = async () => {
    setLoading(true);
    const accountId = sessionStorage.getItem('aid');
    try {
      const response = await AGPAY_API.get(
        `/agpay/v2/payment-settings/accounts/${accountId}`,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
            'Content-Type': 'application/json',
          },
        }
      );
      if (response.status === 200) {
        setDepositPaymentMethodsInfo(response?.data?.deposit_payment_methods);
        const prList = response?.data?.deposit_provider_list;
        let gatewaysCount = 0;
        prList.map((paymentGateway) => {
          if (paymentGateway !== AvailablePaymentGateways.PGMAN)
            gatewaysCount++;
        });
        setPaymentGatewaysCount(gatewaysCount);
        setProvidersList(prList);
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    setPaymentGatewaysCount(0);
    getPaymentProviders();
    if (paymentOption === 'NEFT') {
      fetchPaymentMethod();
    }
    setDepositNotes('');
    setDepositAmount('');
    // setAccountDetails([]);
    setPaymentOption('NEFT');
    setSelectedAccountId('');
    setOnlinePaymentOption('BANK_TRANSFER');
    setPaymentOptionFilter('IMPS');
  }, [tabValue]);

  const submitPayment = async (e) => {
    e.preventDefault();
    if (!depositImage) {
      toast.error(
        <div>
          <ErrorIcon /> {'Please Upload Transaction Image'}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      return false;
    } else if (Number(depositAmount) < 100) {
      toast.error(
        <div>
          <ErrorIcon /> {'Deposit Amount cannot be less than 100'}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      return false;
    }
    setLoading(true);
    try {
      const payload = {
        amount: Number(depositAmount),
        image: depositImage,
        notes: depositNotes,
        payment_method_id: selectedAccountId,
        reference_id: referenceId,
        payment_option:
          paymentOption === 'NEFT'
            ? paymentOptionFilter
            : paymentOption === 'UPI'
            ? 'UPI'
            : 'PAYTM_WALLET',
        amount_modified: ocrDepositAmount !== depositAmount,
        reference_id_modified: ocrReferenceId !== referenceId,
      };

      const response = await AGPAY_API.post(
        `/agpay/v2/pgman/transactions/:deposit`,
        payload,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status === 204) {
        toast.success(
          <div>
            <SuccessIcon /> {'Transaction Saved Successfully!'}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        window.location.href = '/my_transactions';
        setOpenDepositModal(false);
      } else {
        toast.error(
          <div>
            <ErrorIcon /> {response?.data?.message}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      }
      setLoading(false);
    } catch (error) {
      toast.error(
        <div>
          <ErrorIcon /> {error?.response?.data?.message}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );

      setLoading(false);
    }
  };

  const handleCapture = ({ target }) => {
    const fileReader = new FileReader();

    fileReader.readAsDataURL(target.files[0]);
    fileReader.onload = (e) => {
      setDepositImage(e.target.result);
    };
  };

  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  const submitOnlineAmount = async (e) => {
    e.preventDefault();
    if (mobileNumber?.length != 10) {
      toast.error('Invalid Mobile Number');
      return false;
    }
    setLoading(true);

    try {
      const payload = {
        amount: Number(depositAmount),
        currency_type: 'INR',
        mobile_number: mobileNumber,
        notes: depositNotes,
        payment_method:
          onlinePaymentOption === 'UPI' ? 'UPI_TRANSFER' : onlinePaymentOption,
      };
      const response = await AGPAY_API.post(
        `/agpay/v2/abcmoney/transactions/:deposit`,
        payload,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status === 200) {
        if (response.data.payment_options?.length > 0) {
          setPaymentDetails(response.data.payment_options);
          setProviderRefId(response.data.provider_ref_id);
        }
        toast.success(
          <div>
            <SuccessIcon /> {'Transaction Saved Successfully!'}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      }
      setLoading(false);
    } catch (error) {
      toast.error(
        <div>
          <ErrorIcon /> {error?.response?.data?.message}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      setLoading(false);
    }
  };

  const submitXenonPay = async (e) => {
    e.preventDefault();
    if (mobileNumber?.length != 10) {
      toast.error('Invalid Mobile Number');
      return false;
    }
    setLoading(true);

    try {
      const payload = {
        amount: Number(depositAmount),
        mobile_number: mobileNumber,
        notes: depositNotes,
        return_url: `https://${window.location.hostname}`,
      };
      const response = await AGPAY_API.post(
        `/agpay/v2/xenon-pay/transactions/:deposit`,
        payload,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      toast.success(
        <div>
          <SuccessIcon /> {'Transaction Saved Successfully!'}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      window.open(response.data.paymentLink, '_self');
      setLoading(false);
    } catch (error) {
      toast.error(
        <div>
          <ErrorIcon /> {error?.response?.data?.message}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      setLoading(false);
    }
  };

  const confirmPayment = async (e) => {
    e.preventDefault();
    if (!depositImage) {
      toast.error(
        <div>
          <ErrorIcon /> {'Please Upload Transaction Image'}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      return false;
    }
    setLoading(true);

    try {
      const payload = {
        gateway_provider_reference_id: providerRefId,
        utr: referenceId,
        image: depositImage,
        mobile_number: mobileNumber,
        bank_id: paymentDetails?.filter(
          (i) => i?.payment_method === onlinePaymentOption
        )[0].payment_method_details?.bank_id,
        payment_option:
          paymentOption === 'NEFT'
            ? paymentOptionFilter
            : paymentOption === 'UPI'
            ? 'UPI'
            : 'PAYTM_WALLET',
        reference_id_modified: ocrReferenceId !== referenceId,
      };

      const response = await AGPAY_API.post(
        `/agpay/v2/abcmoney/:confirm-payment`,
        payload,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status == 200) {
        toast.success(
          <div>
            <SuccessIcon /> {'Transaction Saved Successfully!'}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        window.location.href = '/my_transactions';
        setOpenDepositModal(false);
      }
      setLoading(false);
    } catch (error) {
      toast.error(
        <div>
          <ErrorIcon /> {error?.response?.data?.message}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );

      setLoading(false);
    }
  };

  const copyText = (text) => {
    navigator.clipboard.writeText(text);
    toast.success('Text Copied!');
  };

  useEffect(() => {
    if (paymentOption) {
      fetchPaymentMethod();
      setAccountDetails([]);
      setSelectedAccountId('');
      setDepositAmount('');
      setDepositImage('');
      setDepositNotes('');
      setReferenceId('');
    }
  }, [paymentOption]);

  useEffect(() => {
    setPaymentDetails([]);
    setDepositAmount('');
    setDepositNotes('');
    setReferenceId('');
    setMobileNumber('');
    setProviderRefId('');
  }, [onlinePaymentOption, tabValue]);

  const renderPaymentForm = (
    paymentGateway: AvailablePaymentGateways,
    index: number,
    tabValue: number
  ) => {
    switch (paymentGateway) {
      case AvailablePaymentGateways.ABCMONEY:
        return (
          <AbcMoney
            index={index}
            onlinePaymentOption={onlinePaymentOption}
            depositPaymentMethodsInfo={depositPaymentMethodsInfo}
            setOnlinePaymentOption={setOnlinePaymentOption}
            tabValue={tabValue}
            submitOnlineAmount={submitOnlineAmount}
            paymentDetails={paymentDetails}
            depositAmount={depositAmount}
            setDepositAmount={setDepositAmount}
            mobileNumber={mobileNumber}
            setMobileNumber={setMobileNumber}
            loading={loading}
            providerRefId={providerRefId}
            confirmPayment={confirmPayment}
            copyText={copyText}
            referenceId={referenceId}
            setReferenceId={setReferenceId}
            paymentOptionFilter={paymentOptionFilter}
            setPaymentOptionFilter={setPaymentOptionFilter}
            depositImage={depositImage}
            handleCapture={handleCapture}
            handleClick={handleClick}
            ref={hiddenFileInput}
          />
        );

      case AvailablePaymentGateways.PGMAN:
        return (
          <Pgman
            index={index}
            tabValue={tabValue}
            paymentOption={paymentOption}
            setPaymentOption={setPaymentOption}
            accountDetails={accountDetails}
            selectedAccountId={selectedAccountId}
            setSelectedAccountId={setSelectedAccountId}
            setSelectedAccount={setSelectedAccount}
            selectedAccount={selectedAccount}
            copyText={copyText}
            paymentOptionFilter={paymentOptionFilter}
            setPaymentOptionFilter={setPaymentOptionFilter}
            submitPayment={submitPayment}
            depositAmount={depositAmount}
            depositNotes={depositNotes}
            referenceId={referenceId}
            setDepositAmount={setDepositAmount}
            setDepositNotes={setDepositNotes}
            setReferenceId={setReferenceId}
            depositImage={depositImage}
            handleCapture={handleCapture}
            handleClick={handleClick}
            loading={loading}
            ref={hiddenFileInput}
          />
        );

      case AvailablePaymentGateways.XENONPAY:
        return (
          <XenonPay
            index={index}
            tabValue={tabValue}
            depositAmount={depositAmount}
            loading={loading}
            mobileNumber={mobileNumber}
            providerRefId={providerRefId}
            setDepositAmount={setDepositAmount}
            setMobileNumber={setMobileNumber}
            submitXenonPay={submitXenonPay}
          />
        );

      default:
        return null;
    }
  };

  return (
    <div className="reports-ctn payment-deposit-ctn">
      {/* {
        providersList?.length === 0 ? (
          <Redirect to="/home" />
        ) : null
      } */}
      {loading ? <Spinner /> : null}
      <div className="header-ctn my-wallet-header">
        <IonRow>
          <div className="img-page-title-row mob-view">
            <img className="title-image" src={deposit} />
            <div className="title">Deposit</div>
          </div>
          <div className="mob-view">
            <Button
              onClick={(e) => {
                history.push('/transaction/withdraw');
              }}
              className="withdraw-deposit-btn actions-btn mob-view"
            >
              Withdraw
            </Button>
          </div>
        </IonRow>

        <div className="deposit-form-ctn">
          {providersList.length === 0 && <div>No Providers Available</div>}
          {providersList?.length > 1 && (
            <Tabs
              value={tabValue}
              onChange={(_, newValue) => {
                setTabValue(newValue);
              }}
            >
              {providersList.map((paymentGateway, index) => (
                <Tab
                  value={index}
                  label={
                    paymentGateway === AvailablePaymentGateways.PGMAN
                      ? 'Manual'
                      : `Auto ${paymentGatewaysCount > 1 ? ++count : ''}`
                  }
                  className="payment-btn"
                />
              ))}
            </Tabs>
          )}
          {providersList?.length > 0 &&
            providersList.map((paymentGateway, index) =>
              renderPaymentForm(paymentGateway, index, tabValue)
            )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {};
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    setOpenDepositModal: (val) => dispatch(setOpenDepositModal(val)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Deposit);
